<template>
<div class="checkbox_wrap">
  <input type="checkbox" :value="value" :id="id" @change="$emit('update:value', Boolean($event.target.value))" :checked="value">
  <label :for="id">
    <span>
      <img src="/img/login_check.svg" alt="">
    </span>
    <p v-html="inputText"></p>
  </label>
</div>
</template>

<script>
/* 2021.04.13 - Nam Sang Woo
 * app-input-checkbox 컴포넌트 
 * attr: inputText, id
 * description: inputText에 텍스트를 넣어서 사용하시면 됩니다. *id 무조건 넣어주세요. label 접근성기준 충족해줘야합니다.
 */ 
export default {
	name: "appInputCheckbox",
	props: {
    value:{
      type: Boolean
    },
    id:{
      type: String,
      default: ""
    },
    inputText:{
      type: String,
      default: ""
    }
	},
};
</script>

<style lang="scss" scoped>
.checkbox_wrap{
    display:flex;
    flex-flow: row nowrap;
    align-items: center;

    input[type="checkbox"] {
        display: none;

        + label{
            position: relative;
            display:flex;
            flex-flow: row nowrap;
            align-items: flex-start;

            p{
                margin:0;
                font-weight: 400;
                color:#323C47;
                font-size:12px;
                margin-left: 5px;
            }
        }

        + label > span {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: center;
            min-width: 16px;
            width: 16px;
            height: 16px;
            border-radius: 4px;
            background: #fff;
            border: 1px solid #D5D5D5;
            box-sizing: border-box;
            content: "";
            margin:0;

            img {
                display: none;
            }
        }

        &:checked {
            + label > span {
                background: #109CF1;
                border: solid 1px #109CF1;
                color: #ffffff;

                img {
                    display: block;
                }
            }
        }
    }
}   
</style>